import { createStore } from 'vuex';
import cookies from './modules/cookies';

export default createStore({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    cookies
  }
});
